import { render, staticRenderFns } from "./ServiceTerms.vue?vue&type=template&id=74d73114&"
import script from "./ServiceTerms.vue?vue&type=script&lang=js&"
export * from "./ServiceTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports